import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import image from "./logo.png";
import "./MainNavbar.css";

export default function MainNavbar({ t, lang, setLang }) {
  const toggleLang = () => setLang(lang === "en" ? "ar" : "en");
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsNavbarCollapsed(true);
    setSearchVisible(false);
  }, [location]);

  return (
    <nav className={`navbar navbar-expand-lg fixed-top shadow-sm ${isScrolled ? "navbar-scrolled" : "navbar-transparent"}`}>
      <div className="container">
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center fw-bold" to="/">
          <img src={image} className="logo-img me-2" alt="logo" />
          <div className="d-flex flex-column">
            <span className="brand-title">Italiano988</span>
            <small className="text-muted">{t("iandex")}</small>
          </div>
        </Link>

        {/* Toggle */}
        <button 
          className="navbar-toggler" 
          type="button"
          onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Links */}
        <div className={`collapse navbar-collapse ${!isNavbarCollapsed ? "show" : ""}`}>
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item"><NavLink end className="nav-link" to="/">{t("welcome")}</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/services">{t("Services")}</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/about">{t("about")}</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/contact">{t("contact")}</NavLink></li>
          </ul>

          {/* Right side */}
          <div className="d-flex align-items-center gap-3">
            {/* Search */}
            <div className={`search-box ${searchVisible ? "active" : ""}`}>
              <input 
                type="text" 
                className="form-control"
                placeholder={t("Search")} 
              />
            </div>
            <button className="btn btn-link search-btn" onClick={() => setSearchVisible(!searchVisible)}>
              <i className="bi bi-search"></i>
            </button>

            {/* Buttons */}
            <Link to="/services" className="btn btn-outline-primary px-3">{t("show_services")}</Link>
            <Link to="/contact" className="btn btn-gradient px-3">{t("prices")}</Link>

            {/* Lang Dropdown */}
            <div className="dropdown">
              <button className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown">
                <i className="bi bi-translate me-1"></i> {lang === "en" ? "English" : "العربية"}
              </button>
              <ul className="dropdown-menu">
                <li><button className="dropdown-item" onClick={() => setLang("en")}>English</button></li>
                <li><button className="dropdown-item" onClick={() => setLang("ar")}>العربية</button></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
